// These fields will be filtered from the data so customers don't see them
const ignore = ['id', 'policy_id', 'policy_version_id'];

const filter = (data: any) => {
  if (data === null || typeof data !== 'object') {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((d) => filter(d));
  }

  const result = {};
  for (const [k, v] of Object.entries(data)) {
    if (!ignore.includes(k)) {
      result[k] = filter(v);
    }
  }
  return result
};

export default filter;
